import _ from 'lodash';
import moment from 'moment';
import {
  Firebase,
  appConfig,
  callIfFunction,
  unwrapDoc,
  goalValueIsSet,
  unwrapDocs,
  logAndDispatchErrorForAction,
  withoutId,
  withoutCreatedOn,
  getCurrentTimestamp,
  accountId,
  organizationId,
  isProduction,
  omitDeleted,
  addKeysAsIds,
  salesforceIntegrationEnabled,
  getDealCompletion,
} from './../util';

import {
  syncSalesforceDeal,
  syncSalesforceData,
} from './integrations/salesforce';

import { OrganizationRef, DealsRef, UsersRef, AccountsRef, DealSnapshotsRef } from './../util/refs';

import {
  FETCH_DEALS,
  FETCH_DEALS_SUCCESS,
  FETCH_DEALS_ERROR,

  FETCH_DEAL,
  FETCH_DEAL_SUCCESS,
  FETCH_DEAL_ERROR,

  SAVE_DEAL,
  SAVE_DEAL_SUCCESS,
  SAVE_DEAL_ERROR,

  SF_ACCOUNT_FOR_DEAL_FETCHED,

} from './types';

export function createOrUpdateDeal(dealData, callback){
  if(dealData._id){
    return updateDeal(dealData, callback);
  }
  else{
    return createDeal(dealData, callback);
  }
}

export function createDeal(newDeal, callback){
  console.log('creating deal!');

  return dispatch => {

    dispatch({
      type: SAVE_DEAL,
      payload: newDeal,
    });

    let newDealData = {
      ...newDeal,
      createdOn: getCurrentTimestamp(),
      lastUpdated: getCurrentTimestamp(),
    }

    DealsRef().add(newDealData).then(dealRef => {

      const newDealId = dealRef.id;

      console.log('deal created with id: ', newDealId);

      DealsRef().doc(newDealId).get().then(doc => {

        const deal = unwrapDoc(doc);

        dispatch({
          type: SAVE_DEAL_SUCCESS,
          payload: deal
        });

        callIfFunction(callback, deal);
      });

    }).catch(err => logAndDispatchErrorForAction('Create deal object', err, dispatch, SAVE_DEAL_ERROR));
  }
}

//TODO implement time range and/or some other filtering mechanisms
export function fetchDealsForEveryone(callback){
  console.log('fetching deals for everyone!');

  return async dispatch => {

    dispatch({
      type: FETCH_DEALS
    });

    try{

      const allDeals = await DealsRef().get();

      // console.log('found deals! : ', unwrapDocs(allDeals));

      return dispatch({
        type: FETCH_DEALS_SUCCESS,
        payload: unwrapDocs(allDeals),
      });

      callIfFunction(callback);

    }
    catch(err){
      return dispatch({
        type: FETCH_DEALS_ERROR,
        payload: err.message
      });
    }
  }
}

export function fetchAllClosedDeals(callback){
  console.log('fetching All Closed Deals!');

  return async dispatch => {

    dispatch({
      type: FETCH_DEALS
    });

    try{

      const wonDealsResults = await DealsRef().where("status", "==", "won").get();
      const lostDealsResults = await DealsRef().where("status", "==", "lost").get();

      const wonDeals = unwrapDocs(wonDealsResults);
      const lostDeals = unwrapDocs(lostDealsResults);

      console.log('fetched closed deals: ', _.union(wonDeals, lostDeals));
      console.log('WON deals count: ', wonDeals.length);
      console.log('LOST deals count: ', lostDeals.length);

      const dealTotals = {
        won: {
          complete: 0,
          total: 0,
          failed: 0,
          incomplete: 0,
          unknown: 0,
        },
        lost: {
          complete: 0,
          total: 0,
          failed: 0,
          incomplete: 0,
          unknown: 0,
        }
      }

      _.each(wonDeals, deal => {
        const itemsCompleteForThisDeal = _.filter(deal.imperativeTasks || {}, task => { return task === 'complete' });
        _.each(deal.imperativeTasks, task => {
          if(task === 'complete'){
            dealTotals.won.complete++;
          }
          else if(task === 'failed'){
            dealTotals.won.failed++;
          }
          else if(task === 'incomplete'){
            dealTotals.won.incomplete++;
          }
          else{
            dealTotals.won.unknown++;
          }
          dealTotals.won.total++;
        });
      });

      _.each(lostDeals, deal => {
        const itemsCompleteForThisDeal = _.filter(deal.imperativeTasks || {}, task => { return task === 'complete' });
        _.each(deal.imperativeTasks, task => {
          if(task === 'complete'){
            dealTotals.lost.complete++;
          }
          else if(task === 'failed'){
            dealTotals.lost.failed++;
          }
          else if(task === 'incomplete'){
            dealTotals.lost.incomplete++;
          }
          else{
            dealTotals.lost.unknown++;
          }
          dealTotals.lost.total++;
        });
      });

      console.log('dealTotals: ', dealTotals);
      console.log('WON deals avg complete: ', Math.round(dealTotals.won.complete / wonDeals.length));
      console.log('LOST deals avg complete: ', Math.round(dealTotals.lost.complete / lostDeals.length));

      return dispatch({
        type: FETCH_DEALS_SUCCESS,
        payload: [
          ...wonDeals,
          ...lostDeals
        ],
      });

      callIfFunction(callback);

    }
    catch(err){
      return dispatch({
        type: FETCH_DEALS_ERROR,
        payload: err.message
      });
    }
  }
}

export function fetchDealActivity(dealId, callback){
  DealSnapshotsRef().doc(dealId).get().then(snapshotsDoc => {
    console.log('got snapshots data: ', snapshotsDoc.data());
    callback(snapshotsDoc.data());
  });
}

export function updateDeal(dealToUpdate, callback){

  const dealId = dealToUpdate._id;

  let updatedDeal = _.cloneDeep(dealToUpdate);

  updatedDeal.confidence = getDealCompletion(updatedDeal).confidence;

  return dispatch => {

    dispatch({
      type: SAVE_DEAL,
      payload: updatedDeal,
    });

    DealsRef().doc(dealId).update({
      ...withoutId(updatedDeal),
      lastUpdated: getCurrentTimestamp(),
    }).then(() => {

      dispatch({
        type: SAVE_DEAL_SUCCESS,
        payload: updatedDeal
      });

      callIfFunction(callback, updatedDeal);

    }).catch(err => logAndDispatchErrorForAction('Update deal object', err, dispatch, SAVE_DEAL_ERROR));
  }
}

export function deleteDeal(dealToDelete, callback){

  return dispatch => {

    const deletedDeal = {
      ...dealToDelete,
      _deleted: true,
      deletedOn: getCurrentTimestamp(),
    }

    dispatch({
      type: SAVE_DEAL,
      payload: deletedDeal,
    });

    DealsRef().doc(dealToDelete._id).update(withoutId(deletedDeal)).then(() => {

      dispatch({
        type: SAVE_DEAL_SUCCESS,
        payload: deletedDeal
      });

      callIfFunction(callback, deletedDeal);

    }).catch(err => logAndDispatchErrorForAction('Delete deal object', err, dispatch, SAVE_DEAL_ERROR));
  }
}

async function fetchSFAccountForDeal(deal){

  if(!deal || !deal.sf || !deal.sf.accountId){
    return null;
  }

  const accountDoc = await AccountsRef().doc(deal.sf.accountId).get();

  return accountDoc && unwrapDoc(accountDoc);
}

export function fetchDeal(dealId, callback){
  console.log('fetching deal with id: ', dealId);

  return async dispatch => {

    dispatch({
      type: FETCH_DEAL,
    });

    try{
      const dealRef = await DealsRef().doc(dealId).get();
      const deal = unwrapDoc(dealRef);

      console.log('fetched deal data: ', deal);

      dispatch({
        type: FETCH_DEAL_SUCCESS,
        payload: deal
      });

      callIfFunction(callback, deal);

      //Whenever deals are fetched, always fetch account from account id & save to local data
      //Might want to refactor this in future to only do as needed, but for now it's easy to do this way, and we'll probably
      //rething the way we create/save/fetch accounts before this is necessary anyway
      const sfAccountForDeal = await fetchSFAccountForDeal(deal);

      if(sfAccountForDeal){
        dispatch({
          type: SF_ACCOUNT_FOR_DEAL_FETCHED,
          payload: sfAccountForDeal
        });
      }
    }
    catch(err){
      logAndDispatchErrorForAction(`Fetch deal ${dealId}`, err, dispatch, FETCH_DEAL_ERROR, callback);
    }
  }
}

async function fetchTeamMemberDeals(memberId){
  const memberDeals = await DealsRef().where('userId', '==', memberId).get().then(docs => {
    return unwrapDocs(docs);
  });

  return memberDeals;
}

export function fetchDealsForTeam(team, callback){
  console.log(`fetching deals for team:`, team);

  return async dispatch => {

    dispatch({
      type: FETCH_DEALS
    });

    try{

      let fetchTeamMemberDealsFunctions = _.map(_.union(team.members, team.leaders), memberId => {
        return fetchTeamMemberDeals(memberId);
      });

      const allTeamMemberDealsArray = await Promise.all(fetchTeamMemberDealsFunctions);

      const allTeamMemberDeals = _.reduce(allTeamMemberDealsArray, (memo, dealsForMember) => {
        return _.union(memo, dealsForMember);
      }, []);

      return dispatch({
        type: FETCH_DEALS_SUCCESS,
        payload: allTeamMemberDeals
      });
    }
    catch(err){
      return logAndDispatchErrorForAction(`Fetch deals for team`, err, dispatch, FETCH_DEALS_ERROR, callback);
    }
  }
}

export function fetchDealsForEmployee(employeeId, callback){
  console.log('fetching deals for user: ', employeeId);

  return async dispatch => {

    dispatch({
      type: FETCH_DEALS,
    });

    try{
      const docs = await DealsRef().where('userId', '==', employeeId).orderBy('createdOn', 'desc').get();

      const deals = unwrapDocs(docs) || [];

      dispatch({
        type: FETCH_DEALS_SUCCESS,
        payload: deals
      });

      callIfFunction(callback, deals);
    }
    catch(err){
      return logAndDispatchErrorForAction(`Fetch deals for user ${employeeId}`, err, dispatch, FETCH_DEALS_ERROR, callback);
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/deals.js